import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "keyboard" }
const _hoisted_2 = { class: "selected-clue-header" }
const _hoisted_3 = { class: "clue-text" }
const _hoisted_4 = { style: {"font-weight":"bold"} }
const _hoisted_5 = { class: "keyline" }
const _hoisted_6 = { class: "keyline" }
const _hoisted_7 = { class: "keyline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.clue?.number) + " " + _toDisplayString(_ctx.xSelect ? "ACROSS" : "DOWN") + ". ", 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.clue?.clue), 1)
      ]),
      _createElementVNode("i", {
        class: "bi bi-chevron-compact-right right-chevron",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitCrosswordKeyEvent('NEXTCLUE')))
      })
    ]),
    _createElementVNode("ul", null, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitCrosswordKeyEvent('Q')))
        }, _cache[29] || (_cache[29] = [
          _createElementVNode("span", { class: "on" }, "Q", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitCrosswordKeyEvent('W')))
        }, _cache[30] || (_cache[30] = [
          _createElementVNode("span", { class: "on" }, "W", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitCrosswordKeyEvent('E')))
        }, _cache[31] || (_cache[31] = [
          _createElementVNode("span", { class: "on" }, "E", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emitCrosswordKeyEvent('R')))
        }, _cache[32] || (_cache[32] = [
          _createElementVNode("span", { class: "on" }, "R", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitCrosswordKeyEvent('T')))
        }, _cache[33] || (_cache[33] = [
          _createElementVNode("span", { class: "on" }, "T", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emitCrosswordKeyEvent('Y')))
        }, _cache[34] || (_cache[34] = [
          _createElementVNode("span", { class: "on" }, "Y", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emitCrosswordKeyEvent('U')))
        }, _cache[35] || (_cache[35] = [
          _createElementVNode("span", { class: "on" }, "U", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.emitCrosswordKeyEvent('I')))
        }, _cache[36] || (_cache[36] = [
          _createElementVNode("span", { class: "on" }, "I", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.emitCrosswordKeyEvent('O')))
        }, _cache[37] || (_cache[37] = [
          _createElementVNode("span", { class: "on" }, "O", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.emitCrosswordKeyEvent('P')))
        }, _cache[38] || (_cache[38] = [
          _createElementVNode("span", { class: "on" }, "P", -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("li", {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.emitCrosswordKeyEvent('A')))
        }, _cache[39] || (_cache[39] = [
          _createElementVNode("span", { class: "on" }, "A", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.emitCrosswordKeyEvent('S')))
        }, _cache[40] || (_cache[40] = [
          _createElementVNode("span", { class: "on" }, "S", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emitCrosswordKeyEvent('D')))
        }, _cache[41] || (_cache[41] = [
          _createElementVNode("span", { class: "on" }, "D", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.emitCrosswordKeyEvent('F')))
        }, _cache[42] || (_cache[42] = [
          _createElementVNode("span", { class: "on" }, "F", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.emitCrosswordKeyEvent('G')))
        }, _cache[43] || (_cache[43] = [
          _createElementVNode("span", { class: "on" }, "G", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.emitCrosswordKeyEvent('H')))
        }, _cache[44] || (_cache[44] = [
          _createElementVNode("span", { class: "on" }, "H", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.emitCrosswordKeyEvent('J')))
        }, _cache[45] || (_cache[45] = [
          _createElementVNode("span", { class: "on" }, "J", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.emitCrosswordKeyEvent('K')))
        }, _cache[46] || (_cache[46] = [
          _createElementVNode("span", { class: "on" }, "K", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.emitCrosswordKeyEvent('L')))
        }, _cache[47] || (_cache[47] = [
          _createElementVNode("span", { class: "on" }, "L", -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("li", {
          class: "special-key",
          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.emitCrosswordKeyEvent('CLOSE')))
        }, _cache[48] || (_cache[48] = [
          _createElementVNode("span", { class: "on" }, [
            _createElementVNode("i", { class: "bi bi-arrow-down-square" })
          ], -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.emitCrosswordKeyEvent('Z')))
        }, _cache[49] || (_cache[49] = [
          _createElementVNode("span", { class: "on" }, "Z", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.emitCrosswordKeyEvent('X')))
        }, _cache[50] || (_cache[50] = [
          _createElementVNode("span", { class: "on" }, "X", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.emitCrosswordKeyEvent('C')))
        }, _cache[51] || (_cache[51] = [
          _createElementVNode("span", { class: "on" }, "C", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.emitCrosswordKeyEvent('V')))
        }, _cache[52] || (_cache[52] = [
          _createElementVNode("span", { class: "on" }, "V", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.emitCrosswordKeyEvent('B')))
        }, _cache[53] || (_cache[53] = [
          _createElementVNode("span", { class: "on" }, "B", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.emitCrosswordKeyEvent('N')))
        }, _cache[54] || (_cache[54] = [
          _createElementVNode("span", { class: "on" }, "N", -1)
        ])),
        _createElementVNode("li", {
          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.emitCrosswordKeyEvent('M')))
        }, _cache[55] || (_cache[55] = [
          _createElementVNode("span", { class: "on" }, "M", -1)
        ])),
        _createElementVNode("li", {
          class: "special-key",
          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.emitCrosswordKeyEvent('BACKSPACE')))
        }, _cache[56] || (_cache[56] = [
          _createElementVNode("span", { class: "on" }, [
            _createElementVNode("i", { class: "bi bi-backspace" })
          ], -1)
        ]))
      ])
    ])
  ]))
}